module.exports = __webpack_public_path__ + "img/79200.82fd8209.jpg";